import { UtilityService }                       from './../_service/utility.service';
import { Component, OnInit, Input, Injector, Attribute }  from '@angular/core';
import { InterfaceService }                     from '../_service/interface.service';
import { FormControl }                          from '@angular/forms';
import { Observable }                           from 'rxjs';
import { LoggedBaseComponent }                  from './LoggedBaseComponent';
import { AttributeService }                     from '../_service/attribute.service';
import ObjectList                               from '../models/ObjectList';
import AttributeSearch                          from '../models/AttributeSearch';
import ModelAttribute                           from '../models/ModelAttribute';

@Component({
  selector      : 'CustomAttributeForm',
  templateUrl   : 'CustomAttributeComponent.html',
})
export class CustomAttributeComponent extends LoggedBaseComponent implements OnInit {
  @Input() options; //model passed from father
  @Input() instance_id; //model passed from father
  
  attributes             : ObjectList<ModelAttribute> = new ObjectList();
  current_attributes     : ObjectList<ModelAttribute> = new ObjectList();
  attribute_search       : AttributeSearch       = new AttributeSearch();
  attribute_loading      : boolean               = false;
  
  attribute_selected     : ModelAttribute        = new ModelAttribute();
  displayed_columns      : string[]              = [ "name" , "value" , "actions" ]
  attribute_value        : string                = null;
  
  optionDataSource  = [];
  original_list     = [];
  option_selected    = null;
  current_option     = null;
  
  title             = "";
  category          = ""
  software_settings = {};
  form_ctrl         = new FormControl();
  filtered_result   : Observable<Attribute[]>;
  
  readonly              : boolean;
  
  constructor
    (
      @Attribute('option-title')    private option_title        : string,
      @Attribute('model_name')      private model_name          : string,
      @Attribute('readonly')      readonly              : boolean,
      private   _attributeService                               : AttributeService,
      protected _utilityService                                 : UtilityService,
      protected _interfaceService                               : InterfaceService,
      injector : Injector
    )
  {
    super(injector);
    this.title    = option_title;
    this.readonly = (readonly === undefined) ? false : readonly;
    this.options  = (this.options === undefined) ? [] : this.options;
    
    this.attribute_search.model_name    = this.model_name;
    this.software_settings              = JSON.parse(sessionStorage.getItem("software_settings"));
    
    
  }
  
  resetAttribute()
  {
      this.attribute_selected               = new ModelAttribute();
      this.attribute_selected.model_name    = this.model_name;
      this.attribute_selected.instance_id   = this.instance_id;
  }
  
  ngOnInit() 
  {
    this.resetAttribute();
    this.getAttributes();
  }
  
  ngAfterViewChecked()
  {
      this.current_attributes.clear();
      for (var attr of this.options)
      {
        this.current_attributes.push(attr , "code");
      }
  }
  
  isAddable()
  {
      return this.attribute_selected.name && this.attribute_value !== null && this.attribute_value !== undefined && this.attribute_value !== ""; 
  }
  
  getAttributes()
  {
      this.attribute_loading  = true;
      this._attributeService.getAttributes(this.attribute_search).subscribe(
        data => {
              for (var current of data["retdata"]["data"])
              {
                  this.attributes.push(new ModelAttribute(current));
              }
              this.attribute_loading  = false;
        },
        err => {
            this.attribute_loading = false;
            this._interfaceService.openSimpleErrorSnackBar(err);
      })
  }
  
  
//   getSelectedValue(data)
//   {
//     this.option_selected = new OptionValue(data); 
//   }
  
//   getElementName(element: OptionValue)
//   {
//     return element === null ? "" : element.name;
//   }
  
//   updateOption(option_id)
//   {
//     var option_in_edit = this.options.filter(obj => {
//                                               return obj.option_id === option_id
//                                             });
//     if (option_in_edit.length > 0)
//     {
//         this.option_selected = new OptionValue(option_in_edit[0]);
//         this.current_option  = new OptionValue(option_in_edit[0]);
//         this.attribute_value    = option_in_edit[0]["value"];
//     }
    
//   }
  
  addOption()
  {
    if (this.attribute_value === null || this.attribute_value === "" || this.attribute_value === undefined )
    {
      this._interfaceService.openSimpleErrorSnackBar("No Value Set");
      return;
    }
    
    this.current_attributes.remove(this.attribute_selected.code);
    this.attribute_selected.value           = this.attribute_value;
    this.attribute_selected.instance_id     = this.instance_id;
    this.current_attributes.push(this.attribute_selected);
    this.current_attributes.pour(this.options);
    
    // //removing same name option to add option as new
    // for( var i = 0; i < this.options.length; i++){ 
    //   if ( this.options[i].name === this.attribute_selected.name) {
    //     this.options.splice(i, 1); 
    //   }
    // }
    // this.attribute_selected.model_name      = this.model_name;
    // this.attribute_selected.instance_id     = this.instance_id;
    // this.attribute_selected.value           = this.attribute_value;
    // this.options.push(Object.assign({} , this.attribute_selected));
    this.resetAttribute();
  }

//   removeOption(option_id)
//   {
//     var isOptionProtected = false;
//     for (var kk in this.options)
//     {
//         var el = this.options[kk];
//         if (el.name === this.software_settings["router_op_name"] && el.option_id == option_id)
//         {
//             isOptionProtected = true;
//         }
//     }
//     if (isOptionProtected)
//     {
//       this._interfaceService.openConfirmDialog(function() { this._removeOption(option_id); }.bind(this),{ "type" : "warning" , "custom_message" : this._translateService.instant("subnets.router_option_delete_warn")});
//     }
//     else
//     {
//       this._removeOption(option_id);
//     }
//   }

    removeOption(attribute_code)
    {
        this.current_attributes.remove(attribute_code);
        this.current_attributes.pour(this.options);
    }
 
}
